module.exports = __webpack_public_path__ + "img/ademe.521053e4.jpg";